import { useState } from "react";
import style from "./Collapsible.module.css";
type Props = {
    title: string,
  children: JSX.Element,
};
const CollapsiblePanel = ({title, children}: Props) => {
    const [open, setOpen] = useState(false);
    const randId = "CollapsiblePanel" + Math.floor(Math.random() * 10000);
  return (
    <div>
      <button className={style.collapseBtn} onClick={() => setOpen(!open)} aria-expanded={open} aria-controls={randId}>
        {title} <i className={`${style.arrow} ${open ? style.up : style.down}`}/>
      </button>
      <div style={{display: open ? "block" : "none"}} className={style.children__wrapper} id={randId}>
        {children}
      </div>
    </div>
  )
}

export default CollapsiblePanel;